import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Wrap,
} from "@chakra-ui/react";
import HoldersCreateHandler from "@raiden/library/containers/Holders/Create/Handler";
import { usePreferences } from "@raiden/library/contexts/Preferences";
import { useCallback, useRef } from "react";
import { FormattedMessage } from "react-intl";
import HoldersFormGeneralInformation from "../Form/GeneralInformation";
import HoldersFormSchooling from "../Form/Schooling";

/**
 * @typedef {Object} Props
 * @property {boolean} isOpen
 * @property {() => void} onClose
 * @property {(params: { holder: import("@raiden/library/types/Holder").Holder }) => void} onSuccess
 *
 * @param {Props} props
 */
function HoldersDialogCreate({ onSuccess, isOpen, onClose }) {
  /** @type {import("react").MutableRefObject<HTMLButtonElement | null>} */
  const ref = useRef(null);

  const { bestEnvironment } = usePreferences();

  const handleSuccess = useCallback(
    ({ holder }) => {
      onClose();
      onSuccess({ holder });
    },
    [onClose, onSuccess],
  );

  return (
    <>
      {bestEnvironment && (
        <HoldersCreateHandler
          environmentId={bestEnvironment.id}
          withForm={false}
          onSuccess={handleSuccess}
          render={({ submit, isLoading }) => (
            <Modal
              initialFocusRef={ref}
              isOpen={isOpen}
              onClose={onClose}
              scrollBehavior="inside"
              size="2xl"
              isCentered>
              <ModalOverlay />

              <ModalContent>
                <ModalHeader>
                  <FormattedMessage defaultMessage="Ajouter un nouvel adhérent" />
                </ModalHeader>

                <ModalCloseButton />

                <ModalBody>
                  <Stack spacing="1rem">
                    <HoldersFormGeneralInformation
                      context="create"
                      isLoading={isLoading}
                    />

                    <HoldersFormSchooling />
                  </Stack>
                </ModalBody>

                <ModalFooter>
                  <Wrap justify="flex-end">
                    <Button onClick={onClose}>
                      <FormattedMessage defaultMessage="Annuler" />
                    </Button>

                    <Button
                      ref={ref}
                      onClick={submit}
                      colorScheme="brandSecondary">
                      <FormattedMessage defaultMessage="Enregistrer" />
                    </Button>
                  </Wrap>
                </ModalFooter>
              </ModalContent>
            </Modal>
          )}
        />
      )}
    </>
  );
}

export default HoldersDialogCreate;
